export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licenseType/state.js